import type { ComponentProps } from "react"
import type { Badge } from "@/components/ui/badge"

type BadgeVariant = NonNullable<ComponentProps<typeof Badge>["variant"]>

const statusVariantMap: Record<string, BadgeVariant> = {
  // Deal statuses
  "Open": "default",
  "Won": "default",
  "Lost": "destructive",

  // Task statuses
  "Todo": "secondary",
  "In Progress": "default",
  "Completed": "default",

  // Task priorities
  "High": "destructive",
  "Medium": "default",
  "Low": "secondary",

  // Team roles
  "Owner": "default",
  "Admin": "default",
  "User": "secondary",

  // General
  "Active": "default",
  "Pending": "secondary",
  "Inactive": "outline",
}

const statusClassMap: Record<string, string> = {
  "Won": "bg-emerald-100 text-emerald-800 border-emerald-200 hover:bg-emerald-100/80 dark:bg-emerald-950 dark:text-emerald-300 dark:border-emerald-800 dark:hover:bg-emerald-950/80",
  "Completed": "bg-emerald-100 text-emerald-800 border-emerald-200 hover:bg-emerald-100/80 dark:bg-emerald-950 dark:text-emerald-300 dark:border-emerald-800 dark:hover:bg-emerald-950/80",
  "Open": "bg-blue-100 text-blue-800 border-blue-200 hover:bg-blue-100/80 dark:bg-blue-950 dark:text-blue-300 dark:border-blue-800 dark:hover:bg-blue-950/80",
  "In Progress": "bg-amber-100 text-amber-800 border-amber-200 hover:bg-amber-100/80 dark:bg-amber-950 dark:text-amber-300 dark:border-amber-800 dark:hover:bg-amber-950/80",
  "Todo": "bg-slate-100 text-slate-800 border-slate-200 hover:bg-slate-100/80 dark:bg-slate-800 dark:text-slate-300 dark:border-slate-700 dark:hover:bg-slate-800/80",
  "High": "bg-red-100 text-red-800 border-red-200 hover:bg-red-100/80 dark:bg-red-950 dark:text-red-300 dark:border-red-800 dark:hover:bg-red-950/80",
  "Medium": "bg-amber-100 text-amber-800 border-amber-200 hover:bg-amber-100/80 dark:bg-amber-950 dark:text-amber-300 dark:border-amber-800 dark:hover:bg-amber-950/80",
  "Low": "bg-slate-100 text-slate-800 border-slate-200 hover:bg-slate-100/80 dark:bg-slate-800 dark:text-slate-300 dark:border-slate-700 dark:hover:bg-slate-800/80",
  "Active": "bg-emerald-100 text-emerald-800 border-emerald-200 hover:bg-emerald-100/80 dark:bg-emerald-950 dark:text-emerald-300 dark:border-emerald-800 dark:hover:bg-emerald-950/80",
  "Lost": "bg-red-100 text-red-800 border-red-200 hover:bg-red-100/80 dark:bg-red-950 dark:text-red-300 dark:border-red-800 dark:hover:bg-red-950/80",
  "Pending": "bg-amber-100 text-amber-800 border-amber-200 hover:bg-amber-100/80 dark:bg-amber-950 dark:text-amber-300 dark:border-amber-800 dark:hover:bg-amber-950/80",
}

export function getStatusVariant(status: string): BadgeVariant {
  return statusVariantMap[status] || "outline"
}

export function getStatusClasses(status: string): string {
  return statusClassMap[status] || ""
}
